import Base from "@/plugins/Base";

const module = {
    namespaced: true,
    state: () => ({
        slot_type:null,
        program_code:null
    }),
    getters: {
        getSlotType(state) {
            return Base.LocalStorage.get("slot_type");
        },
        getProgramCode(state) {
            return Base.LocalStorage.get("program_code");
        },
    },
    mutations: {
        setSlotType(state, value) {
            state.slot_type = value;
            if (value){
                Base.LocalStorage.set("slot_type", value);
            }else{
                Base.LocalStorage.removeItem("slot_type");
            }
        },
        setProgramCode(state, value) {
            state.program_code = value;
            if (value){
                Base.LocalStorage.set("program_code", value);
            }else{
                Base.LocalStorage.removeItem("program_code");
            }
        },
    },
    actions: {
        setSlotType({commit}, value) {
            commit('setSlotType', value)
        },
        setProgramCode({commit}, value) {
            commit('setProgramCode', value)
        },
        clearSlotInformation({commit}) {
            commit('setSlotType', null);
            commit('setProgramCode', null);
        }

    }
}

export default module;
